<template>
  <div class="tw-flex tw-items-center">
    <ul class="tw-flex tw-body-small tw-justify-start lg:tw-justify-end">
      <li 
        v-for="item in items" 
        :key="`breadcrumb-${item.path}`" 
        class="tw-flex tw-items-center tw-whitespace-nowrap">
        <span v-if="item.path">
          <NuxtLink 
            :to="item.path" 
            :title="item.title"
            class="tw-text-black hover:!tw-text-secondary tw-transition-colors tw-duration-300">
            {{ item.title }}
          </NuxtLink>
          <QIcon 
            name="chevron_right" 
            class="tw-px-1" />
        </span>
        <span 
          v-else-if="!item.path" 
          :title="item.title"
          class="tw-text-dark-gray tw-truncate tw-inline-block tw-max-w-[200px] tw-align-middle">
          {{ item.title }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  items: {
    type: Array as () => BreadCrumb[],
    default: () => ([]),
  },
})
</script>
